














// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import OptionComp from "@/components/OptionComp.vue";
@Component({
  components: {
    OptionComp,
    Dialog,
    ErrorList
  }
})
export default class Option extends HacoCommon {
  // put something
}
